import "./../css/components/Horario.css"

let dias = [
    {
        "dia": "LUNES",
        "color" : "uno",
        "desde": "10:00",
        "hasta": "00:00"
    },
    {
        "dia": "MARTES",
        "color" : "dos",
        "desde": "10:00",
        "hasta": "00:00"
    },
    {
        "dia": "MIÉRCOLES",
        "color" : "tres",
        "desde": "10:00",
        "hasta": "00:00"
    },
    {
        "dia": "JUEVES",
        "color" : "cuatro",
        "desde": "10:00",
        "hasta": "00:00"
    },
    {
        "dia": "VIERNES",
        "color" : "cinco",
        "desde": "10:00",
        "hasta": "01:00"
    },
    {
        "dia": "SÁBADO",
        "color" : "seis",
        "desde": "10:00",
        "hasta": "01:00"
    },
    {
        "dia": "DOMINGO",
        "color" : "siete",
        "desde": "10:00",
        "hasta": "00:00"
    },
]

const getDayOfWeek = () => {
    const daysOfWeek = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
    const today = new Date();
    const dayIndex = today.getDay();
    return daysOfWeek[dayIndex].toUpperCase();
  };

  

function Horario() {
    return (
      <section className='historia'>
        {dias.map((dia)=>
        <div className={dia.dia == getDayOfWeek() ? "destacado" : "caja"}>
            <div className={"flecha " + dia.color}>
                <div className="flecha__texto" >
                    {dia.dia}
                </div>
            </div> 
            <div className="hora">
                {dia.desde} A {dia.hasta}
            </div> 
        </div>          
        )}
      </section>
    );
  }
  
  export default Horario;